import React from 'react';

import {
  useTranslation,
} from 'react-i18next';

import AppIcon
  from '../../../shared/ui/AppIcon';

export default function FindAccountForm({
  email,
  error,
  isSubmitting,
  isCompleted,

  resetLoginId,
  resetEmail,
  resetError,
  isResetSubmitting,
  isResetCompleted,

  onEmailChange,
  onSubmit,

  onResetLoginIdChange,
  onResetEmailChange,
  onPasswordResetSubmit,

  onBack,
  onContactSales,
}) {
  const {
    t,
  } =
    useTranslation(
      'login',
    );


  return (
    <div
      className="
        login-form
        find-account-form
      "
    >

      <form
        className="find-account-form-section"
        onSubmit={
          onSubmit
        }
        noValidate
        aria-busy={
          isSubmitting
        }
      >
        <div
          className="find-account-header"
        >
          <h2>
            {t(
              'findAccount.title',
            )}
          </h2>
        </div>


        {!isCompleted ? (
          <>
            <div
              className="form-group"
            >
              <label
                htmlFor="companyEmail"
              >
                {t(
                  'findAccount.email.label',
                )}
              </label>

              <input
                id="companyEmail"
                name="companyEmail"
                type="email"
                value={
                  email
                }
                onChange={
                  onEmailChange
                }
                placeholder={
                  t(
                    'findAccount.email.placeholder',
                  )
                }
                autoComplete="email"
                maxLength={200}
                disabled={
                  isSubmitting ||
                  isResetSubmitting
                }
                aria-invalid={
                  Boolean(
                    error,
                  )
                }
              />
            </div>


            {error && (
              <p
                className="login-error"
                role="alert"
                aria-live="polite"
              >
                {error}
              </p>
            )}


            <button
              type="submit"
              className="
                login-button
                find-account-submit-button
              "
              disabled={
                isSubmitting ||
                isResetSubmitting
              }
            >
              <span>
                {
                  isSubmitting
                    ? t(
                        'findAccount.submitting',
                      )
                    : t(
                        'findAccount.submit',
                      )
                }
              </span>

              {!isSubmitting && (
                <AppIcon
                  type="arrow"
                  size={17}
                />
              )}
            </button>
          </>
        ) : (
          <div
            className="find-account-result"
          >
            <strong>
              {t(
                'findAccount.result.title',
              )}
            </strong>

            <p>
              {t(
                'findAccount.result.description',
              )}
            </p>
          </div>
        )}
      </form>


      <div
        className="find-account-divider"
      />


      <form
        className="find-account-form-section"
        onSubmit={
          onPasswordResetSubmit
        }
        noValidate
        aria-busy={
          isResetSubmitting
        }
      >
        <div
          className="find-account-header"
        >
          <h2>
            {t(
              'passwordReset.title',
            )}
          </h2>
        </div>


        {!isResetCompleted ? (
          <>
            <div
              className="form-group"
            >
              <label
                htmlFor="resetLoginId"
              >
                {t(
                  'passwordReset.userId.label',
                )}
              </label>

              <input
                id="resetLoginId"
                name="resetLoginId"
                type="text"
                value={
                  resetLoginId
                }
                onChange={
                  onResetLoginIdChange
                }
                placeholder={
                  t(
                    'passwordReset.userId.placeholder',
                  )
                }
                autoComplete="username"
                maxLength={100}
                disabled={
                  isResetSubmitting ||
                  isSubmitting
                }
              />
            </div>


            <div
              className="form-group"
            >
              <label
                htmlFor="resetEmail"
              >
                {t(
                  'passwordReset.email.label',
                )}
              </label>

              <input
                id="resetEmail"
                name="resetEmail"
                type="email"
                value={
                  resetEmail
                }
                onChange={
                  onResetEmailChange
                }
                placeholder={
                  t(
                    'passwordReset.email.placeholder',
                  )
                }
                autoComplete="email"
                maxLength={200}
                disabled={
                  isResetSubmitting ||
                  isSubmitting
                }
                aria-invalid={
                  Boolean(
                    resetError,
                  )
                }
              />
            </div>


            {resetError && (
              <p
                className="login-error"
                role="alert"
                aria-live="polite"
              >
                {resetError}
              </p>
            )}


            <button
              type="submit"
              className="
                login-button
                find-account-submit-button
              "
              disabled={
                isResetSubmitting ||
                isSubmitting
              }
            >
              <span>
                {
                  isResetSubmitting
                    ? t(
                        'passwordReset.submitting',
                      )
                    : t(
                        'passwordReset.submit',
                      )
                }
              </span>

              {!isResetSubmitting && (
                <AppIcon
                  type="arrow"
                  size={17}
                />
              )}
            </button>
          </>
        ) : (
          <div
            className="find-account-result"
          >
            <strong>
              {t(
                'passwordReset.result.title',
              )}
            </strong>

            <p>
              {t(
                'passwordReset.result.description',
              )}
            </p>
          </div>
        )}
      </form>


      <div
        className="find-account-actions"
      >
        <button
          type="button"
          className="text-button"
          onClick={
            onBack
          }
          disabled={
            isSubmitting ||
            isResetSubmitting
          }
        >
          {t(
            'findAccount.backToLogin',
          )}
        </button>

        <button
          type="button"
          className="text-button"
          onClick={
            onContactSales
          }
          disabled={
            isSubmitting ||
            isResetSubmitting
          }
        >
          {t(
            'findAccount.contactSales',
          )}
        </button>
      </div>
    </div>
  );
}